







import {Component, Vue, Watch} from 'vue-property-decorator'
import {checkMobile} from "../../utils/utils";

@Component
export default class Meeting extends Vue {
  mobile: boolean = checkMobile()
  path: string = ''

  beforeMount() {
    this.path = "/classroom/meeting" + window.location.hash.replace(/^#/, '')
  }

  @Watch('$route')
  watchRoute(to) {
    this.path = "/classroom/meeting" + to.hash.replace(/^#/, '')

  }

  embedLoad() {
    const embed = this.$refs.embed as any
    const embedPath = embed.contentWindow.location.href
    if (embedPath.endsWith("bookings")) {
      // TODO: fix POST request
      return
    }
    window.location.hash = embedPath.match(/\/classroom\/meeting(.*)/)[1]
  }
}
